module.exports = __webpack_public_path__ + "img/saint-etienne-logo-icon.eb06d6c4.png";